export enum FeedDistributionMoveTypes {
    Received = 'Received',
    MovedIn = 'Moved In',
    Shipped = 'Shipped',
    MovedOut = 'Moved Out',
    Realized = 'Realized',
    Mortalitied = 'Mortalitied',
    Baseline = 'Baseline',
}

export enum FeedDistributionScenarios {
    HasNoEstimatedHead = 'HasNoEstimatedHead',
    CreatingDistributionWithNoEstimatedHead = 'CreatingDistributionWithNoEstimatedHead',
    HasEstimatedHead = 'HasEstimatedHead',
    CreatingDistributionWithEstimatedHead = 'CreatingDistributionWithEstimatedHead',
    HasPreviouslySavedDistribution = 'HasPreviouslySavedFeedDistribution',
    UpdatingDistribution = 'UpdatingFeedDistribution',
    PreviouslySavedDistributionIsOutOfSync = 'PreviouslySavedDistributionIsOutOfSync',
    RevertToOutOfSync = 'RevertToOutOfSync',
    NoCattle = 'NoCattle',
    NoMovements = 'NoMovements',
}
